import React, { useState } from "react";
import "../styles/radioForm.scss";

const SurveyQuestion = ({
  topic,
  answers = [],
  onChange,
  required = true,
  questionNumber = 1,
  displayType = "radio", // 'radio' or 'button'
  numberColor = "#0066fe", // 기본값
  answerColor = "#0066fe", // 기본값
}) => {
  const [selected, setSelected] = useState("");

  const handleChange = (value) => {
    setSelected(value);
    onChange?.(value);
  };

  if (displayType === "button") {
    return (
      <div
        className="survey-item"
        style={{
          "--answer-color": answerColor,
        }}
      >
        <div className="survey-question">
          <span className="survey-question-no" style={{ color: numberColor }}>
            Q{questionNumber}.
          </span>
          <p className="survey-question-text">{topic}</p>
        </div>
        <div className="survey-answers-button">
          {answers.map((answer, idx) => (
            <label
              key={idx}
              className={`survey-answer-button ${
                selected === answer ? "selected" : ""
              }`}
              style={
                selected === answer ? { backgroundColor: answerColor } : {}
              }
            >
              <input
                type="radio"
                name={`survey-${questionNumber}`}
                value={answer}
                checked={selected === answer}
                onChange={() => handleChange(answer)}
                required={required}
              />
              <span
                className="check-mark"
                style={{ display: selected === answer ? "inline" : "none" }}
              >
                ✓
              </span>
              <span
                className="answer-text"
                style={selected === answer ? { color: "white" } : {}}
              >
                {answer}
              </span>
            </label>
          ))}
        </div>
      </div>
    );
  }

  // Default: radio type
  return (
    <div
      className="survey-item"
      style={{
        "--answer-color": answerColor,
      }}
    >
      <div className="survey-question">
        <span className="survey-question-no" style={{ color: numberColor }}>
          Q{questionNumber}.
        </span>
        <p className="survey-question-text">{topic}</p>
      </div>
      <div className="survey-answers-radio">
        {answers.map((answer, idx) => (
          <label key={idx} className="survey-answer-option">
            <input
              type="radio"
              name={`survey-${questionNumber}`}
              value={answer}
              checked={selected === answer}
              onChange={() => handleChange(answer)}
              required={required}
            />
            <span>{answer}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default SurveyQuestion;
